import { render, staticRenderFns } from "./ArrowBack.vue?vue&type=template&id=5ab87346"
import script from "./ArrowBack.vue?vue&type=script&lang=js"
export * from "./ArrowBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports